type UnauthorizedHandler = () => Promise<boolean>; // true => retry the request

let onUnauthorized: UnauthorizedHandler = async () => false;

/** Registered once by @astro/auth so a 401 triggers a silent token refresh. */
export function setUnauthorizedHandler(handler: UnauthorizedHandler): void {
  onUnauthorized = handler;
}

export function handleUnauthorized(): Promise<boolean> {
  return onUnauthorized();
}
